module.exports = __webpack_public_path__ + "static/media/ai_agents_image.a6c6d275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ai_agents_image.jpg
// module id = 317
// module chunks = 0